import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import Header from "@arelia-components/layout/Header";
import PublishingRoyaltiesDetailsContainer from "./PublishingRoyaltiesDetailsContainer";

export default function PublishingRoyaltiesDetails() {
  return (
    <ContentBox>
      <Header
        title="Publishing Royalties"
        backTo={{
          label: "back to earnings",
          path: "/earnings"
        }}
      />
      <PublishingRoyaltiesDetailsContainer />
    </ContentBox>
  );
}
